import api from '@/api'

const actions = {
    async getLives ({ commit, state }) {
        const { data } = await api.get(`lives_${ window.location.host.indexOf('bradesco') > -1 || state.theme == 'bradesco' ? 'br' : state.locale}.json`)
        commit('SET_LIVES', data)
    },
    async getWorkouts ({ commit, state }) {
        const { data } = await api.get(`${ window.location.host.indexOf('bradesco') > -1 || state.theme == 'bradesco' ? 'br' : state.locale}.json`)
        commit('SET_WORKOUTS', data)
    },
    async getBanners ( { commit, state } ) {
        const { data } = await api.get(`banners_${ window.location.host.indexOf('bradesco') > -1 || state.theme == 'bradesco' ? 'br' : state.locale}.json`)
        commit('SET_BANNERS', data)
    },
    async getKits ( { commit, state } ) {
        const { data } = await api.get(`kits_${ window.location.host.indexOf('bradesco') > -1 || state.theme == 'bradesco' ? 'br' : state.locale}.json`)
        commit('SET_KITS', data)
    },
    async getLayoutParts ( { commit, state } ) {
        const { data } = await api.get(`layout_parts_${ window.location.host.indexOf('bradesco') > -1 || state.theme == 'bradesco' ? 'br' : state.locale}.json`)
        commit('SET_LAYOUTPARTS', data)
    },
    async getVideos ({ commit, state }) {
        const { data } = await api.get(`videos_${ window.location.host.indexOf('bradesco') > -1 || state.theme == 'bradesco' ? 'br' : state.locale}.json`)
        commit('SET_VIDEOS', data)
    },
    setActiveWorkout ({ commit, state }, payload) {
        let activeWorkout = state.workouts.find( w => w.slug == payload )
        commit('SET_ACTIVEWORKOUT', activeWorkout )
    },
    setActiveVideo ({ commit, state }, payload) {
        let activeVideo = state.videos.find( w => w.slug == payload )
        commit('SET_ACTIVEVIDEO', activeVideo )
    },
    setActiveKit ({ commit, state }, payload) {
        if(payload.category && state.kits[payload.category]) {
            let activeKit = state.kits[payload.category].kits.find( w => w.slug == payload.slug )
            commit('SET_ACTIVEKIT', activeKit )
        }
    },
}

export default actions
